<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{ `${document.translatedKind} - ${translatedOwner}` }}
          </h4>
        </div>

        <div class="modal-body">
          <div class="row" v-if="document.status === 'reproved' && document.newStatus">
            <div class="col-xs-12">
              <div class="alert alert-danger" role="alert">
                Atenção, você reprovou este documento, mas não salvou a alteração, portanto, se você excluir o
                documento, o mesmo perderá seu histórico de upload
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <file-input
                v-for="(doc, index) in attachments"
                :key="index"
                v-model="doc.value"
                :alias="doc.translatedKind"
                :preview-url="doc.previewUrl"
                :status="document.status"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="$emit('close')"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-danger"
            v-if="canDeleteDocument"
            @click="showConfirmModal = true;"
          >
            Excluir documento
          </button>
          <button
            class="btn btn-success"
            v-show="!hasAttachmentKindNullValue"
            @click="sendFile"
            type="button"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
    <confirm-modal v-if="showConfirmModal" @close="showConfirmModal = false;" @confirm="deleteDocument()" />
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';
  @import 'assets/stylesheets/utils/_colors.sass';

  .document__preview {
    width: 100%;
  }

  .document__pdf-preview {
    min-height: 50vh;
    width: 100%;
  }

  .label--document-status {
    color: $white;
    display: inline-block;
    font-size: 1rem;
    margin: auto 1rem;
    vertical-align: middle;
  }

  .modal-body {
    max-height: 70vh;
    overflow-y:auto;
  }

  .modal-body__row:not(:last-child) {
    margin-bottom: $space-m;
  }
</style>
<script>
import FileInput from 'pages/Parcelamento/StudentView/PaymentPlanData/FileInput';
import ParcelamentoService from 'services/ParcelamentoService';
import ConfirmModal from 'components/ConfirmModal';

export default {
  components: {
    FileInput,
    ConfirmModal,
  },
  props: {
    owner: {
      type: String,
      required: true,
    },
    translatedOwner: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    paymentPlan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      attachments: [],
      showConfirmModal: false,
    };
  },
  computed: {
    canDeleteDocument() {
      return this.document.id && (this.document.status !== 'reproved' || this.document.newStatus);
    },
    hasAttachmentKindNullValue() {
      return Boolean(this.attachments.filter(attachment => attachment.value === null).length);
    },
  },
  created() {
    this.fillAttachments();
  },
  methods: {
    b64toBlob(b64Data, contentType, sliceSize) {
      // eslint-disable-next-line no-param-reassign
      contentType = contentType || '';
      // eslint-disable-next-line no-param-reassign
      sliceSize = sliceSize || 512;

      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    createFormData() {
      const formData = new FormData();
      formData.append('owner', this.owner);
      formData.append('kind', this.document.kind);
      formData.append('payment_plan_id', this.paymentPlan.id);
      this.attachments
        .forEach((document) => {
          const block = document.value.split(';');
          const contentType = block[0].split(':')[1];
          const realData = block[1].split(',')[1];
          formData.append(document.kind, this.b64toBlob(realData, contentType));
        });
      return formData;
    },
    sendFile() {
      const formData = this.createFormData();
      this.$loader.show();
      ParcelamentoService.addPaymentPlanDocument(this.paymentPlan.id, formData)
        .then(({ data }) => {
          this.$alert.notifySuccess('Documento enviado com sucesso.');
          this.$emit('change', data);
          this.$emit('close');
        })
        .catch(() => this.$alert.notifyAlert('Falha ao enviar documento, tente novamente mais tarde'))
        .finally(() => {
          this.$loader.hide();
        });
    },
    fillAttachments() {
      if (
        (this.document.status === 'reproved' && !this.document.newStatus)
        || !this.document.attachments
        || this.document.attachments.length === 0
      ) {
        this.attachments = [
          {
            kind: 'front',
            translatedKind: 'Frente',
            value: null,
          },
        ];

        if (this.document.doubleSide) {
          this.attachments.push({
            kind: 'back',
            translatedKind: 'Verso',
            value: null,
          });
        }
      } else {
        this.attachments = this.document.attachments;
      }
    },
    deleteDocument() {
      this.showConfirmModal = false;
      this.$loader.show();
      ParcelamentoService.deletePaymentPlanDocument(this.paymentPlan.id, this.document.id)
        // eslint-disable-next-line no-unused-vars
        .then((_response) => {
          this.$alert.notifySuccess('Documento excluido com sucesso.');
          this.$emit(
            'change',
            {
              status: 'pendent', translatedStatus: 'Pendente', id: null, attachments: null,
            },
          );
          this.fillAttachments();
        })
        .catch(() => this.$alert.notifyAlert('Falha ao enviar documento, tente novamente mais tarde'))
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
